const DownloadIcon = (props) => (
  <svg
    width='8'
    height='11'
    viewBox='0 0 8 11'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8 3.69231H5.71429V0H2.28571V3.69231H0L4 8L8 3.69231ZM0 10V11H8V10H0Z'
      fill='currentColor'
    />
  </svg>
)

export default DownloadIcon
